import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const ArrowForwardMaterial = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </IconSvg>
);

export default ArrowForwardMaterial;
